import VehiclesError from './VehiclesError.js'

export class GetSubscriptionModelsNotFoundVehiclesError extends VehiclesError {}
